import { useAuthContext } from '../context/AuthContext';

export const useUserImage = () => {
  const { userImage, loadUserImage, updateUserImage } = useAuthContext();

  return {
    // 画像URL（Firebaseから取得 - CORS エラー時はこちらを優先）
    imageUrl: userImage.url,
    // 画像データ（base64形式）
    imageData: userImage.data,
    // ローディング状態
    isLoading: userImage.loading,
    // エラー状態
    error: userImage.error,
    // 画像が利用可能かどうか（URLまたはbase64データが存在）
    hasImage: !!(userImage.url || userImage.data),
    // 画像を再読み込み
    reload: loadUserImage,
    // 画像を更新
    update: updateUserImage
  };
}; 